export default from './search-menu';



// WEBPACK FOOTER //
// ./app/containers/search-menu/index.js